import HomePage from '@/pages/home/HomePage.tsx'
import { RouteObject } from 'react-router-dom'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const HOME_ROUTES: RouteObject[] = [
  {
    path: '',
    element: <HomePage />,
    errorElement: <ErrorPage />
  }
]

export default HOME_ROUTES
